import { ShowcaseEffects } from '../effects/showcase.effect';

export const effects: any[] = [ShowcaseEffects];

export * from './showcase.effect';
